import {useTranslation} from "react-i18next";
import React from "react";
import Mixpanel from "../utils/mixpanel";

const LANGUAGES = [
    {value: "en", label: "English", flag: "🇬🇧"},
    {value: "it", label: "Italiano", flag: "🇮🇹"},
    {value: "fr", label: "Furlan", flag: "🇫"},
];

const LangSwitch = () => {
    const {i18n} = useTranslation("global");

    const handleLanguageChange = (language: string) => {
        i18n.changeLanguage(language);
        Mixpanel.track("Language changed", {
            language: language,
        });
    };

    return (
        <div className="w-full flex justify-end items-center mb-4 md:absolute md:top-4 md:right-4 md:mb-0">
            <select
                onChange={(e) => handleLanguageChange(e.target.value)}
                value={i18n.language}
                className="appearance-none bg-white backdrop-blur-md rounded-xl px-5 py-1.5
                         text-black font-medium border-2 border-white/20
                         focus:outline-none focus:ring-2 focus:ring-white/40
                         cursor-pointer hover:bg-white/25 hover:border-white/30 
                         transition-all duration-300 ease-in-out
                         shadow-sm hover:shadow-md"
            >
                <option value="en">🇬🇧 English</option>
                <option value="it">🇮🇹 Italiano</option>
                <option value="fr">🇫 Furlan</option>
            </select>
        </div>
    );
};

export default LangSwitch;
